import { useCallback } from "react";
import { Drawer as DrawerType } from "melco-shared-logic";
import { Drawer, FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useViewerLink } from "../../../../hooks/reporting/useViewerLink";
import { DisplayGenerateViewerLinkForm } from "./DisplayGenerateViewerLinkForm";
import { DisplayDetailViewerLinkForm } from "./DisplayDetailViewerLinkForm";
import styled from "styled-components";
import LoadingDefaultSpinIndicator from "../../../loading/LoadingDefaultSpinIndicator";

export type ViewerLinkSteps = "viewerLink" | "setPermissions" | "finish";

type ViewerLinkDrawerProps = {
  drawer: DrawerType;
  viewId: string | null | undefined;
};

const LoaderDiv = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; /* keeps it above other content */
`;

export const ViewerLinkDrawer: React.FC<ViewerLinkDrawerProps> = ({
  drawer,
  viewId,
}) => {
  const { t } = useTranslation();
  const { data: viewerLinkDetail, refetch, isLoading, isFetching } = useViewerLink(viewId);
  const { closeDrawer, isDrawerOpen } = drawer;

  const closeAndReset = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);



  return (
    <Drawer
      title={t("reporting.machinestatus.view.viewerlink.drawer.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeAndReset}
      open={isDrawerOpen}
    //  loading={(isLoading || isFetching)}
    >

      <FullWidthSpace direction="vertical">

        {/* --- Loading spinner inside Drawer --- */}
        {(isLoading || isFetching) && (
          <LoaderDiv>
            <LoadingDefaultSpinIndicator isShown={true} />
          </LoaderDiv>
        )}

        {/* --- Show Generate form when no viewerLink exists --- */}

        {!isLoading && !isFetching && !viewerLinkDetail && (
          <>
            <DisplayGenerateViewerLinkForm
              callbackViewerLinkDetail={() => {
                refetch();
              }}
            />
          </>
        )}

        {!isLoading && !isFetching && viewerLinkDetail && (
          <>
            <DisplayDetailViewerLinkForm
              viewId={viewId ?? ""}
              viewerLinkDetail={viewerLinkDetail}
              closeAndReset={closeAndReset}
            />
          </>
        )}
      </FullWidthSpace>
    </Drawer>
  );
};
